import BlockListRequests from "app/api/block-list";
import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";
import { I18n } from "react-redux-i18n";
import { message } from "antd";

export const ACTION_SAVE_CLIENTS_BLOCKLIST =
  "client:ACTION_SAVE_CLIENTS_BLOCKLIST";
export const ACTION_SAVE_CLIENT_BLOCKLIST =
  "client:ACTION_SAVE_CLIENT_BLOCKLIST";

export const ACTION_SAVE_CITIES_BLOCKLIST =
  "client:ACTION_SAVE_CITIES_BLOCKLIST";
export const ACTION_SAVE_CITY_BLOCKLIST = "client:ACTION_SAVE_CITY_BLOCKLIST";

export const fetchClientsBlockList = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await BlockListRequests.fetchClientsBlockList(params);
    dispatch({ type: ACTION_SAVE_CLIENTS_BLOCKLIST, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchClientBlockListById = id => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await BlockListRequests.fetchClientBlockListById(id);
    dispatch({ type: ACTION_SAVE_CLIENT_BLOCKLIST, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const createClientBlockList = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.createClientBlockList(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateClientBlockList = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.updateClientBlockList(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteClientBlockList = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.deleteClientBlockList(id);
    callback();
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const importCsvClientBlockList = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await BlockListRequests.importCsvClientBlockList(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadClientBlockListCSV = params => async () => {
  if (params.searchParameter?.InitialDate) {
    try {
      const response = await BlockListRequests.downloadClientBlockListCSV(
        params.searchParameter
      );
      const link = document.createElement("a");
      link.href = response.data;
      link.setAttribute("download", "block_list.csv");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      handleGenericApiError(err);
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

// Cities

export const fetchCitiesBlockList = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await BlockListRequests.fetchCitiesBlockList(params);
    dispatch({ type: ACTION_SAVE_CITIES_BLOCKLIST, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchCityBlockListById = id => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await BlockListRequests.fetchCityBlockListById(id);
    dispatch({ type: ACTION_SAVE_CITY_BLOCKLIST, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchLocalesBlockList = id => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await BlockListRequests.fetchLocalesBlockList(id);
    return data;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const createCityBlockList = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.createCityBlockList(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateCityBlockList = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.updateCityBlockList(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteCityBlockList = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await BlockListRequests.deleteCityBlockList(id);
    callback();
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const importCsvCityBlockList = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    let response = await BlockListRequests.importCsvCityBlockList(data);
    if (callback && typeof callback === "function") {
      callback();
    }
    return response;
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadCityBlockListCSV = params => async () => {
  if (params.searchParameter?.InitialDate) {
    try {
      const response = await BlockListRequests.downloadCityBlockListCSV(
        params.searchParameter
      );
      const link = document.createElement("a");
      link.href = response.data;
      link.setAttribute("download", "block_list_cities.csv");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      handleGenericApiError(err);
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};
